import { render, staticRenderFns } from "./ClinicSelector.vue?vue&type=template&id=72c60cd5&scoped=true"
import script from "./ClinicSelector.vue?vue&type=script&lang=js"
export * from "./ClinicSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c60cd5",
  null
  
)

export default component.exports